import React, { FC, useCallback, useEffect, useState } from "react";
import "moment/locale/es";

type DeviceType = "sm" | "md" | "lg";
interface TemplateProps {
  device?: DeviceType;
  menu_toggle: () => void;
  menu_collapsed: boolean;
  // width: number;
}

export const TemplateContext = React.createContext<TemplateProps>(null);
const cal_sm = (size: number) => size <= 425;
const cal_md = (size: number) => size > 425 && size <= 768;
const cal_lg = (size: number) => size > 768;
const cal_device = (size: number): DeviceType => {
  if (cal_sm(size)) {
    return "sm";
  } else if (cal_md(size)) {
    return "md";
  } else if (cal_lg(size)) {
    return "lg";
  } else {
    return "lg";
  }
};

const TemplateProvider: FC = React.memo(({ children }) => {
  const [device, setDevice] = useState<DeviceType>(
    cal_device(window.innerWidth)
  );
  const [menu_collapsed, setMenu_collapsed] = useState<boolean>(false);

  const updateDimensions = useCallback(() => {
    const _width: number = window.innerWidth;
    let _device = cal_device(_width);
    if (_device !== device) {
      setDevice(_device);
    }
  }, [device]);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions.bind(this));
    window.addEventListener("load", updateDimensions.bind(this));
    return () => {
      window.removeEventListener("load", updateDimensions.bind(this));
      window.removeEventListener("resize", updateDimensions.bind(this));
    };
  }, [device]);

  return (
    <TemplateContext.Provider
      value={{
        device,
        menu_collapsed,
        menu_toggle: () => setMenu_collapsed((collapsed) => !collapsed),
      }}
    >
      {children}
    </TemplateContext.Provider>
  );
});

export default TemplateProvider;
